import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a25bd6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['activity-recommmend-box'])
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "save-btn"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "推荐有礼", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "recommend-bg-top",
  src: "https://p6.moimg.net/md/activity/recommend/recommend_bg_top.png"
}, null, -1));
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"recommmend-tit\" data-v-2a25bd6c><span data-v-2a25bd6c>金币奖励</span></div><div class=\"tips\" data-v-2a25bd6c>邀请新人发布创意或众筹提审/上线/成功你可获得奖励</div><div class=\"reward-list\" data-v-2a25bd6c><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>成功邀请新商家</span><span class=\"limit\" data-v-2a25bd6c>（限5人）</span><div class=\"num\" data-v-2a25bd6c>100</div><span class=\"coin\" data-v-2a25bd6c>金币</span></div><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>邀请的新商家创意上线</span><span class=\"limit\" data-v-2a25bd6c>（限3人）</span><div class=\"num\" data-v-2a25bd6c>500</div><span class=\"coin\" data-v-2a25bd6c>金币</span></div><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>邀请的新商家众筹项目提审</span><span class=\"limit\" data-v-2a25bd6c>（限3人）</span><div class=\"num\" data-v-2a25bd6c>1000</div><span class=\"coin\" data-v-2a25bd6c>金币</span></div><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>邀请的新商家众筹项目上线</span><span class=\"limit\" data-v-2a25bd6c>（不限）</span><div class=\"num\" data-v-2a25bd6c>3000</div><span class=\"coin\" data-v-2a25bd6c>金币</span></div><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>邀请的新商家众筹成功</span><span class=\"limit\" data-v-2a25bd6c>（不限）</span><div class=\"num\" data-v-2a25bd6c>3500</div><span class=\"coin\" data-v-2a25bd6c>金币</span></div></div><div class=\"line\" data-v-2a25bd6c></div><div class=\"recommmend-tit\" data-v-2a25bd6c><span data-v-2a25bd6c>挖矿分奖励</span></div><div class=\"tips\" data-v-2a25bd6c>邀请新人提审众筹你可获得奖励</div><div class=\"reward-list\" data-v-2a25bd6c><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>成功邀请新商家</span><span class=\"limit\" data-v-2a25bd6c>（限5人/周）</span><div class=\"num\" data-v-2a25bd6c>1</div><span class=\"coin\" data-v-2a25bd6c>分</span></div><div class=\"reward-item\" data-v-2a25bd6c><span class=\"label\" data-v-2a25bd6c>邀请的新商家众筹项目提交审核</span><span class=\"limit\" data-v-2a25bd6c>（限1次/周）</span><div class=\"num\" data-v-2a25bd6c>2</div><span class=\"coin\" data-v-2a25bd6c>分</span></div></div><div class=\"line\" data-v-2a25bd6c></div>", 8);
const _hoisted_15 = {
  class: "recommmend-tit"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的邀请", -1));
const _hoisted_17 = {
  class: "member"
};
const _hoisted_18 = {
  class: "invite-box"
};
const _hoisted_19 = {
  key: 0,
  class: "invite-list"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "name"
};
const _hoisted_22 = {
  key: 1,
  class: "empty",
  src: "https://p6.moimg.net/mdwxapp/empty_focus_icon.png"
};
const _hoisted_23 = {
  key: 0,
  class: "btn-group"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_ShareBox = _resolveComponent("ShareBox");
  const _component_Poster = _resolveComponent("Poster");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.showImg ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "saveimg-box",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closeShowImg && $options.closeShowImg(...args))
  }, [_createElementVNode("img", {
    src: $data.imgSrc
  }, null, 8, _hoisted_2), $data.env.isWeixin() ? (_openBlock(), _createElementBlock("div", _hoisted_3, "长按图片点击「保存图片」")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$data.env.isWeixin() ? (_openBlock(), _createBlock(_component_van_sticky, {
    key: 0,
    onChange: $options.handleStickyAction
  }, {
    default: _withCtx(() => [_createElementVNode("header", {
      class: _normalizeClass([{
        'headerAndroid': $data.env.isModianAndroid()
      }, {
        'isFix': $data.isFix
      }])
    }, [_createVNode(_component_van_image, {
      class: "back-btn",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_btn.png', 32),
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.handleGoBack(), ["stop"]))
    }, null, 8, ["src"]), _hoisted_4], 2)]),
    _: 1
  }, 8, ["onChange"])) : _createCommentVNode("", true), _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, "已邀请" + _toDisplayString($data.inviteList.length) + "人", 1), _createElementVNode("span", {
    class: "more",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goScorePromotion && $options.goScorePromotion(...args))
  }, "奖励明细")]), _createElementVNode("div", _hoisted_18, [$data.inviteList.length ? (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.inviteList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "invite-item",
      key: index
    }, [_createElementVNode("img", {
      class: "icon",
      src: item.icon
    }, null, 8, _hoisted_20), _createElementVNode("div", _hoisted_21, _toDisplayString(item.nickname), 1)]);
  }), 128))])) : (_openBlock(), _createElementBlock("img", _hoisted_22))]), $data.showShareBtn ? (_openBlock(), _createElementBlock("div", _hoisted_23, [($data.env.isModianIos() || $data.env.isModianAndroid()) && $data.systemVersion > '62410250' || $data.env.isWeixin() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.generateImage && $options.generateImage(...args))
  }, "生成图片")) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "btn copyBtn",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.shareMore && $options.shareMore(...args))
  }, "立即邀请")])) : _createCommentVNode("", true)]), _createVNode(_component_ShareBox)], 64)), _createVNode(_component_Poster, {
    ref: "poster",
    shareInfo: $data.shareInfo,
    cpInfo: $data.cpInfo,
    onUpdateImgSrc: $options.updateImgSrc
  }, null, 8, ["shareInfo", "cpInfo", "onUpdateImgSrc"])]);
}